import { Injectable } from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from "rxjs/Observable";
import { environment } from '../../environments/environment';

@Injectable()
 export class Config {
 private _config: Object;
 private _env: Object;
 private _flagInit = false;
 constructor(private http: Http) {
 }
 load() {
   if (this._config == null) {

      console.log("load Config");
      return new Promise((resolve, reject) => {
        this.http.get(environment.basePath + environment.env + '.json')
        .map(res => res.json())
        .catch((error: any) => {
          console.error(error);
          return Observable.throw(error.json().error || 'Server error');
        })
        .subscribe((data) => {
          this._flagInit = true;
          this._config = data;
          resolve(true);
        });
      });
      
   }
   
 }

 getEnv(key: any) {
   return (this._env != null ? this._env[key] : null);
 }
 get(key: any) {

  if(! this._flagInit) {
    this.load();
  }

   return (this._config != null ? this._config[key] : null);
 }
 getData() {
  return this.http.get(environment.basePath + environment.env + '.json')
    .map(res => res.json());
  }

};


// WEBPACK FOOTER //
// ./src/app/config/config.ts